import React, { Component } from 'react';
import axios from 'axios';
import { withTranslation } from "react-i18next";

class Question6 extends Component {
	constructor(props) {
		super(props);
		this.state = {
      val: '',
			email: ''
		};

    this.sendFeedback = this.sendFeedback.bind(this);
    this.changeEmail = this.changeEmail.bind(this);
		this.changeRadio = this.changeRadio.bind(this);
		this.closeFeedback = this.closeFeedback.bind(this);
	}

	componentDidMount() {
		// scroll back to top page
		window.scrollTo(0, 0);

	}

	render() {

    return(
      <div className="feedback-question">
				<h2>{this.props.t('Question6-Wil je dat wij contact met jou opnemen over jouw feedback?')}</h2>
        <p>{this.props.t('Question6-Bedankt voor jouw feedback')}.</p>
        <p>{this.props.t('Question6-Wil je dat wij contact met jou opnemen over jouw feedback, bijvoorbeeld om jouw probleem op te lossen, of om uit te leggen wat we met jouw feedback gaan doen?')}</p>
        <div className="input-container row">
          <div className="col-12">
            <div className="form-check">
              <input className="form-check-input" type="radio" name="option" id="option1" value="yes" onChange={this.changeRadio}/>
              <label className="form-check-label" htmlFor="option1">
                {this.props.t('Question6-Ja graag')}
              </label>
            </div>
            <div className="form-check">
              <input className="form-check-input" type="radio" name="option" id="option2" value="no" onChange={this.changeRadio}/>
              <label className="form-check-label" htmlFor="option2">
                {this.props.t('Question6-Nee niet nodig')}
              </label>
            </div>

          </div>
          <div className="col-12">
            <input className="input" type="email" value={this.state.email} placeholder="E-mail:" onChange={this.changeEmail}/>
          </div>
        </div>
        <div className="button-container row">


          <div className="col">
            <button className="btn btn-primary col" onClick={() => {this.sendFeedback()}}>{this.props.t('Question6-Verstuur')}</button>
          </div>
        </div>
      </div>
    )
	}


  changeEmail = function (event) {
    let value = event.target.value;
    this.setState({email : value});
  }

	changeRadio = function (event) {
		let value = event.target.value;
		this.setState({type : value});
	}

  sendFeedback = function () {
    let type = this.state.type;
		let email = this.state.email;
		if(type === 'yes' && !email) {
			alert('Vul je e-mail in zodat we contact met je kunnen opnemen');
			return null;
		}
		let sessionId = localStorage.getItem('sessionId');
    let url = "/feedback/negative-contact";
		let data = {
			'session_id' : sessionId,
			'type' : type,
			'email' : email
		}
    axios.post(url, data).then(response => {
      this.props.nextQuestion(6);
		}).catch(response => {
      console.log('error');
		})
  }

	closeFeedback = function () {
		this.props.nextQuestion(6);
	}

}

export default withTranslation('result')(Question6);
